import { useMutation } from "react-query";

import { uploadBulkRescheduleCsv } from "../../../../../api/logistics/bulkReschedule";
import { notification } from "antd";

export const useUploadBulkRescheduleCsv = () => {
  const {
    mutate: uploadCsv,
    isLoading: isUploading,
    isSuccess,
  } = useMutation(uploadBulkRescheduleCsv, {
    onSuccess() {
      notification.success({
        message: "Upload Success",
        description: `The result will be sent to your email shortly`,
      });
    },
    onError(error) {
      notification.error({
        message: "Upload Error",
        description: `${error}`,
      });
    },
  });

  return { uploadCsv, isUploading, isSuccess };
};
